import { AppBar, Stack, Box, Tooltip, Autocomplete, CircularProgress, Toolbar, TextField, Modal, useTheme, Table, TableCell, TableBody,  TableContainer, TableHead, TableRow, IconButton, Button, Menu, MenuItem, ListItemIcon, ListItemText, Divider, CssBaseline, alpha, useMediaQuery, Typography, LinearProgress, } from "@mui/material";
import { tokens } from "../../../theme/theme";
import TableFilterRow from "../../../components/table/TableFilterRow";

const ProductionReportTable = ({ columns, filters, handleFilterChangeTable, uniqueValues, autoCompleteColumns, currentRecords }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    return (<>
        <Table size="small">
            <TableHead sx={{ backgroundColor: colors.primary[400] }}>

                <TableRow>

                    <TableCell
                        colSpan={23}
                        align="center"
                    >
                        {/* Today */}
                    </TableCell>
                    <TableCell />
                    <TableCell
                        colSpan={4}
                        align="center"
                        sx={{ bgcolor: colors.blueAccent[200], fontWeight: 600 }}
                    >
                        PLANNING
                    </TableCell>
                    <TableCell align="center" sx={{ bgcolor: colors.blueAccent[200], fontWeight: 600 }} />
                    <TableCell
                        colSpan={4}
                        align="center"
                        sx={{ bgcolor: colors.orangeAccent[200], fontWeight: 600 }}
                    >
                        JUMBO
                    </TableCell>
                    <TableCell
                        colSpan={2}
                        align="center"
                        sx={{ bgcolor: colors.orangeAccent[200], fontWeight: 600 }}
                    >

                    </TableCell>
                    <TableCell
                        colSpan={12}
                        align="center"
                        sx={{ bgcolor: colors.greenAccent[400], fontWeight: 600 }}
                    >
                        REWINDER
                    </TableCell>
                    <TableCell
                        colSpan={14}
                        align="center"
                        sx={{ bgcolor: colors.orangeAccent[400], fontWeight: 600 }}
                    >
                        REEL
                    </TableCell>
                    <TableCell
                        colSpan={12}
                        align="center"
                        sx={{ bgcolor: colors.purpleAccent[400], fontWeight: 600 }}
                    >
                        SHEETING
                    </TableCell>

                    <TableCell
                        colSpan={12}
                        align="center"
                        sx={{ bgcolor: colors.yellowAccent[400], fontWeight: 600 }}
                    >
                        REAM
                    </TableCell>

                    <TableCell
                        colSpan={12}
                        align="center"
                        sx={{ bgcolor: colors.orangeAccent[400], fontWeight: 600 }}
                    >
                        BUNDLE QTY
                    </TableCell>
                    <TableCell
                        colSpan={10}
                        align="center"
                        sx={{ bgcolor: colors.purpleAccent[400], fontWeight: 600 }}
                    >
                        REAM PALLET
                    </TableCell>
                    <TableCell
                        colSpan={9}
                        align="center"
                        sx={{ bgcolor: colors.greenAccent[600], fontWeight: 600 }}
                    >
                        FG RECEVING
                    </TableCell>
                    <TableCell
                        colSpan={7}
                        align="center"
                        sx={{ bgcolor: colors.blueAccent[600], fontWeight: 600 }}
                    >
                        DISPATCH
                    </TableCell>
                </TableRow>

                {/* second line */}
                <TableRow>
                    <TableCell sx={{ bgcolor: colors.blueAccent[400], textAlign: 'center' }}>MONTH</TableCell>
                    <TableCell sx={{ bgcolor: colors.blueAccent[400], textAlign: 'center' }}>REGION</TableCell>
                    <TableCell sx={{ bgcolor: colors.blueAccent[400], textAlign: 'center' }}>CUSTOMER NAME</TableCell>
                    <TableCell sx={{ bgcolor: colors.blueAccent[400], textAlign: 'center' }}>CONSIGNEE NAME</TableCell>
                    {/* new */}
                    <TableCell sx={{ bgcolor: colors.blueAccent[400], textAlign: 'center' }}>DELIVERY NAME</TableCell>
                    <TableCell sx={{ bgcolor: colors.blueAccent[400], textAlign: 'center' }}>DESTINATION</TableCell>

                    <TableCell sx={{ bgcolor: colors.blueAccent[400], textAlign: 'center' }}>ORDER STATUS</TableCell>
                    {/* <TableCell sx={{ textAlign: 'center' }}>DELIVERY AREA</TableCell> not available */}
                    <TableCell sx={{ bgcolor: colors.blueAccent[400], textAlign: 'center' }}>ORDER BLOCK</TableCell>
                    <TableCell sx={{ bgcolor: colors.blueAccent[400], textAlign: 'center' }}>QUALITY</TableCell>
                    <TableCell sx={{ bgcolor: colors.blueAccent[400], textAlign: 'center' }}>GSM</TableCell>
                    <TableCell sx={{ bgcolor: colors.blueAccent[400], textAlign: 'center' }}>WIDTH (cm)</TableCell>
                    <TableCell sx={{ bgcolor: colors.blueAccent[400], textAlign: 'center' }}>LENGTH (cm)</TableCell>
                    <TableCell sx={{ bgcolor: colors.blueAccent[400], textAlign: 'center' }}>PACKING MODE</TableCell>
                    <TableCell sx={{ bgcolor: colors.blueAccent[400], textAlign: 'center' }}>SO DATE</TableCell>
                    <TableCell sx={{ bgcolor: colors.blueAccent[400], textAlign: 'center' }}>REQUIRE DELIVERY DATE</TableCell>
                    <TableCell sx={{ bgcolor: colors.blueAccent[400], textAlign: 'center' }}>SAP PO DATE</TableCell>
                    <TableCell sx={{ bgcolor: colors.blueAccent[400], textAlign: 'center' }}>SAP PO.NO</TableCell>
                    <TableCell sx={{ bgcolor: colors.blueAccent[400], textAlign: 'center' }}>SAP PO ITEM LINE</TableCell>
                    <TableCell sx={{ bgcolor: colors.blueAccent[400], textAlign: 'center' }}>SO.NO</TableCell>
                    <TableCell sx={{ bgcolor: colors.blueAccent[400], textAlign: 'center' }}>SO ITEM LINE</TableCell>
                    <TableCell sx={{ bgcolor: colors.blueAccent[400], textAlign: 'center' }}>PARTY PO.NO.</TableCell>
                    <TableCell sx={{ bgcolor: colors.blueAccent[400], textAlign: 'center' }}>PARTY PO DATE</TableCell>
                    <TableCell sx={{ bgcolor: colors.blueAccent[400], textAlign: 'center' }}>SO.NO & ITEM LINE</TableCell>

                    {/* old modal */}

                    {/* <TableCell sx={{ textAlign: 'center' }}>SO.NO</TableCell>
                                        <TableCell sx={{ textAlign: 'center' }}>ITEM LINE</TableCell>

                                        <TableCell sx={{ textAlign: 'center' }}>L/ORDER PUNCH DATE</TableCell> */}
                    <TableCell sx={{ bgcolor: colors.redAccent[400], textAlign: 'center' }} >ORDER QTY</TableCell>
                    {/* MO DETAIL */}
                    <TableCell sx={{ bgcolor: colors.blueAccent[200], textAlign: 'center' }}>NO OF DECKLE PLAN</TableCell>
                    <TableCell sx={{ bgcolor: colors.blueAccent[200], textAlign: 'center' }}>DECKLE QTY</TableCell>
                    <TableCell sx={{ bgcolor: colors.blueAccent[200], textAlign: 'center' }}>DECKLE FIRST DATE</TableCell>
                    <TableCell sx={{ bgcolor: colors.blueAccent[200], textAlign: 'center' }}>DECKLE LAST DATE</TableCell>
                    <TableCell sx={{ bgcolor: colors.redAccent[400], textAlign: 'center' }}>MACHINE PENDING ORDER</TableCell>

                    {/* PARENT ROLL  */}
                    <TableCell sx={{ bgcolor: colors.orangeAccent[200], textAlign: 'center' }}>NO OF M/C ROLL</TableCell>
                    <TableCell sx={{ bgcolor: colors.orangeAccent[200], textAlign: 'center' }}>M/C QTY</TableCell>
                    <TableCell sx={{ bgcolor: colors.orangeAccent[200], textAlign: 'center' }}>M/C FIRST DATE</TableCell>
                    <TableCell sx={{ bgcolor: colors.orangeAccent[200], textAlign: 'center' }}>M/C LAST DATE</TableCell>
                    <TableCell colSpan={2} sx={{ bgcolor: colors.redAccent[400], textAlign: 'center' }}>WIP </TableCell>


                    {/* Winder Process Detail */}
                    <TableCell colSpan={2} sx={{ bgcolor: colors.greenAccent[400], textAlign: 'center' }}>REWINDER (TOTAL) </TableCell>
                    <TableCell colSpan={2} sx={{ bgcolor: colors.greenAccent[400], textAlign: 'center' }}>REWINDER (G1)</TableCell>
                    <TableCell colSpan={2} sx={{ bgcolor: colors.greenAccent[400], textAlign: 'center' }}>REWINDER (SL)</TableCell>
                    <TableCell colSpan={2} sx={{ bgcolor: colors.greenAccent[400], textAlign: 'center' }}>REWINDER (BUFFER)</TableCell>
                    <TableCell colSpan={2} sx={{ bgcolor: colors.greenAccent[400], textAlign: 'center' }}>REWINDER (REPULP)</TableCell>
                    <TableCell colSpan={2} sx={{ bgcolor: colors.greenAccent[400], textAlign: 'center' }}>REWINDER (UNAPPROVED)</TableCell>
                    <TableCell sx={{ bgcolor: colors.greenAccent[400], textAlign: 'center' }}>RW FIRST DATE</TableCell>
                    <TableCell sx={{ bgcolor: colors.greenAccent[400], textAlign: 'center' }}>RW LAST DATE</TableCell>

                    {/* reel weighment */}
                    <TableCell colSpan={2} sx={{ bgcolor: colors.orangeAccent[400], textAlign: 'center' }}>REEL (TOTAL)</TableCell>
                    <TableCell colSpan={2} sx={{ bgcolor: colors.orangeAccent[400], textAlign: 'center' }}>REEL (G1)</TableCell>
                    <TableCell colSpan={2} sx={{ bgcolor: colors.orangeAccent[400], textAlign: 'center' }}>REEL (SL)</TableCell>
                    <TableCell colSpan={2} sx={{ bgcolor: colors.orangeAccent[400], textAlign: 'center' }}>REEL (REPULP)</TableCell>
                    <TableCell sx={{ bgcolor: colors.orangeAccent[400], textAlign: 'center' }}>REEL PROD. FIRST DATE</TableCell>
                    <TableCell sx={{ bgcolor: colors.orangeAccent[400], textAlign: 'center' }}>REEL PROD. LAST DATE</TableCell>
                    <TableCell colSpan={2} sx={{ bgcolor: colors.redAccent[400], textAlign: 'center' }}>WIP </TableCell>

                    {/* sheeter process */}

                    <TableCell colSpan={2} sx={{ bgcolor: colors.purpleAccent[400], textAlign: 'center' }}>SHEET (TOTAL)</TableCell>
                    <TableCell colSpan={2} sx={{ bgcolor: colors.purpleAccent[400], textAlign: 'center' }}>REEL QTY (G1)</TableCell>
                    <TableCell colSpan={2} sx={{ bgcolor: colors.purpleAccent[400], textAlign: 'center' }}>REEL QTY (SL)</TableCell>
                    <TableCell colSpan={2} sx={{ bgcolor: colors.purpleAccent[400], textAlign: 'center' }}>REEL QTY (REPULP)</TableCell>
                    <TableCell sx={{ bgcolor: colors.purpleAccent[400], textAlign: 'center' }}>SHEETING FIRST DATE</TableCell>
                    <TableCell sx={{ bgcolor: colors.purpleAccent[400], textAlign: 'center' }}>SHEETING LAST DATE</TableCell>
                    <TableCell colSpan={2} sx={{ bgcolor: colors.redAccent[400], textAlign: 'center' }}>WIP SHEET QTY</TableCell>


                    {/* ream punching */}
                    <TableCell colSpan={2} sx={{ bgcolor: colors.yellowAccent[400], textAlign: 'center' }}>REAM (TOTAL)</TableCell>
                    <TableCell colSpan={2} sx={{ bgcolor: colors.yellowAccent[400], textAlign: 'center' }}>REAM QTY (G1) </TableCell>
                    <TableCell colSpan={2} sx={{ bgcolor: colors.yellowAccent[400], textAlign: 'center' }}>REAM QTY (SL)</TableCell>
                    <TableCell colSpan={2} sx={{ bgcolor: colors.yellowAccent[400], textAlign: 'center' }}>REAM QTY (REPULP) </TableCell>
                    <TableCell sx={{ bgcolor: colors.yellowAccent[400], textAlign: 'center' }}>REAM PROD. FIRST DATE</TableCell>
                    <TableCell sx={{ bgcolor: colors.yellowAccent[400], textAlign: 'center' }}>REAM PROD. LAST DATE</TableCell>
                    <TableCell colSpan={2} sx={{ bgcolor: colors.redAccent[400], textAlign: 'center' }}>WIP</TableCell>


                    {/* bundle */}
                    <TableCell colSpan={2} sx={{ bgcolor: colors.orangeAccent[400], textAlign: 'center' }}>BUNDLE (TOTAL)</TableCell>
                    <TableCell colSpan={2} sx={{ bgcolor: colors.orangeAccent[400], textAlign: 'center' }}>BUNDLE (G1)</TableCell>
                    <TableCell colSpan={2} sx={{ bgcolor: colors.orangeAccent[400], textAlign: 'center' }}>BUNDLE (SL)</TableCell>
                    <TableCell colSpan={2} sx={{ bgcolor: colors.orangeAccent[400], textAlign: 'center' }}>BUNDLE (REPULP)</TableCell>
                    <TableCell sx={{ bgcolor: colors.orangeAccent[400], textAlign: 'center' }}>BUNDLE PROD. FIRST DATE</TableCell>
                    <TableCell sx={{ bgcolor: colors.orangeAccent[400], textAlign: 'center' }}>BUNDLE PROD.LAST DATE</TableCell>
                    <TableCell colSpan={2} sx={{ bgcolor: colors.redAccent[400], textAlign: 'center' }}>WIP</TableCell>

                    {/* ream pallet */}
                    <TableCell colSpan={2} sx={{ bgcolor: colors.purpleAccent[400], textAlign: 'center' }}>REAM PALLET (TOTAL)</TableCell>
                    <TableCell colSpan={2} sx={{ bgcolor: colors.purpleAccent[400], textAlign: 'center' }}>REAM PALLET (G1)</TableCell>
                    <TableCell colSpan={2} sx={{ bgcolor: colors.purpleAccent[400], textAlign: 'center' }}>REAM PALLET (SL)</TableCell>
                    <TableCell colSpan={2} sx={{ bgcolor: colors.purpleAccent[400], textAlign: 'center' }}>REAM PALLET (REPULP)</TableCell>
                    <TableCell sx={{ bgcolor: colors.purpleAccent[400], textAlign: 'center' }}>REAM PALLET PROD. FIRST DATE</TableCell>
                    <TableCell sx={{ bgcolor: colors.purpleAccent[400], textAlign: 'center' }}>REAM PALLET PROD.LAST DATE</TableCell>
                    {/* <TableCell colSpan={2} sx={{ bgcolor: colors.redAccent[400], textAlign: 'center' }}>WIP</TableCell> */}

                    <TableCell sx={{ bgcolor: colors.greenAccent[600], textAlign: 'center' }}>LODGE (TOTAL) QTY</TableCell>
                    <TableCell sx={{ bgcolor: colors.greenAccent[600], textAlign: 'center' }}>LODGE (G1) QTY </TableCell>
                    <TableCell sx={{ bgcolor: colors.greenAccent[600], textAlign: 'center' }}>LODGE (SL) QTY </TableCell>
                    <TableCell sx={{ bgcolor: colors.greenAccent[600], textAlign: 'center' }}>LODGE (REPULP) QTY </TableCell>
                    <TableCell sx={{ bgcolor: colors.greenAccent[600], textAlign: 'center' }}>LODGEING FIRST DATE</TableCell>
                    <TableCell sx={{ bgcolor: colors.greenAccent[600], textAlign: 'center' }}>LODGEING LAST DATE</TableCell>
                    <TableCell sx={{ bgcolor: colors.redAccent[400], textAlign: 'center' }}>WIP LODGE QTY</TableCell>
                    <TableCell sx={{ bgcolor: colors.redAccent[400], textAlign: 'center' }}>REPULP </TableCell>
                    <TableCell sx={{ bgcolor: colors.redAccent[400], textAlign: 'center' }}>SHORT FALL % </TableCell>

                    {/* invoice */}
                    <TableCell sx={{ bgcolor: colors.blueAccent[600], textAlign: 'center' }}>SAP FG QTY</TableCell>
                    <TableCell sx={{ bgcolor: colors.blueAccent[600], textAlign: 'center' }}>SAP FG FIRST DATE </TableCell>
                    <TableCell sx={{ bgcolor: colors.blueAccent[600], textAlign: 'center' }}>SAP FG LAST DATE </TableCell>
                    <TableCell sx={{ bgcolor: colors.blueAccent[600], textAlign: 'center' }}>DISPATCH QTY </TableCell>
                    <TableCell sx={{ bgcolor: colors.blueAccent[600], textAlign: 'center' }}>DISPATCH FIRST DATE</TableCell>
                    <TableCell sx={{ bgcolor: colors.blueAccent[600], textAlign: 'center' }}>DISPATCH LAST DATE</TableCell>
                    <TableCell sx={{ bgcolor: colors.blueAccent[600], textAlign: 'center' }}>OA BALANCE</TableCell>

                </TableRow>


                <TableRow>

                    <TableCell sx={{ bgcolor: colors.blueAccent[400], textAlign: 'center' }}> </TableCell>
                    <TableCell sx={{ bgcolor: colors.blueAccent[400], textAlign: 'center' }}> </TableCell>
                    <TableCell sx={{ bgcolor: colors.blueAccent[400], textAlign: 'center' }}> </TableCell>
                    <TableCell sx={{ bgcolor: colors.blueAccent[400], textAlign: 'center' }}> </TableCell>
                    {/* new */}
                    <TableCell sx={{ bgcolor: colors.blueAccent[400], textAlign: 'center' }}></TableCell>
                    <TableCell sx={{ bgcolor: colors.blueAccent[400], textAlign: 'center' }}></TableCell>
                    <TableCell sx={{ bgcolor: colors.blueAccent[400], textAlign: 'center' }}></TableCell>
                    <TableCell sx={{ bgcolor: colors.blueAccent[400], textAlign: 'center' }}></TableCell>
                    <TableCell sx={{ bgcolor: colors.blueAccent[400], textAlign: 'center' }}></TableCell>
                    <TableCell sx={{ bgcolor: colors.blueAccent[400], textAlign: 'center' }}></TableCell>
                    <TableCell sx={{ bgcolor: colors.blueAccent[400], textAlign: 'center' }}></TableCell>
                    <TableCell sx={{ bgcolor: colors.blueAccent[400], textAlign: 'center' }}></TableCell>
                    <TableCell sx={{ bgcolor: colors.blueAccent[400], textAlign: 'center' }}></TableCell>
                    <TableCell sx={{ bgcolor: colors.blueAccent[400], textAlign: 'center' }}></TableCell>
                    <TableCell sx={{ bgcolor: colors.blueAccent[400], textAlign: 'center' }}></TableCell>
                    <TableCell sx={{ bgcolor: colors.blueAccent[400], textAlign: 'center' }}></TableCell>
                    <TableCell sx={{ bgcolor: colors.blueAccent[400], textAlign: 'center' }}></TableCell>
                    <TableCell sx={{ bgcolor: colors.blueAccent[400], textAlign: 'center' }}></TableCell>
                    <TableCell sx={{ bgcolor: colors.blueAccent[400], textAlign: 'center' }}></TableCell>
                    <TableCell sx={{ bgcolor: colors.blueAccent[400], textAlign: 'center' }}></TableCell>
                    <TableCell sx={{ bgcolor: colors.blueAccent[400], textAlign: 'center' }}></TableCell>
                    <TableCell sx={{ bgcolor: colors.blueAccent[400], textAlign: 'center' }}></TableCell>
                    <TableCell sx={{ bgcolor: colors.blueAccent[400], textAlign: 'center' }}></TableCell>

                    {/* old modal */}
                    {/* <TableCell sx={{ textAlign: 'center' }}>SO.NO</TableCell>
                                        <TableCell sx={{ textAlign: 'center' }}>ITEM LINE</TableCell>
                                        <TableCell sx={{ textAlign: 'center' }}>L/ORDER PUNCH DATE</TableCell> */}


                    <TableCell sx={{ bgcolor: colors.redAccent[400], textAlign: 'center' }} ></TableCell>
                    {/* MO DETAIL */}
                    <TableCell sx={{ bgcolor: colors.blueAccent[200], textAlign: 'center' }}></TableCell>
                    <TableCell sx={{ bgcolor: colors.blueAccent[200], textAlign: 'center' }}></TableCell>
                    <TableCell sx={{ bgcolor: colors.blueAccent[200], textAlign: 'center' }}></TableCell>
                    <TableCell sx={{ bgcolor: colors.blueAccent[200], textAlign: 'center' }}></TableCell>
                    <TableCell sx={{ bgcolor: colors.redAccent[400], textAlign: 'center' }}></TableCell>

                    {/* PARENT ROLL  */}
                    <TableCell sx={{ bgcolor: colors.orangeAccent[200], textAlign: 'center' }}></TableCell>
                    <TableCell sx={{ bgcolor: colors.orangeAccent[200], textAlign: 'center' }}></TableCell>
                    <TableCell sx={{ bgcolor: colors.orangeAccent[200], textAlign: 'center' }}></TableCell>
                    <TableCell sx={{ bgcolor: colors.orangeAccent[200], textAlign: 'center' }}></TableCell>
                    <TableCell sx={{ bgcolor: colors.redAccent[400], textAlign: 'center' }}>JUMBO QTY</TableCell>
                    <TableCell sx={{ bgcolor: colors.redAccent[400], textAlign: 'center' }}>NO OF REELS</TableCell>

                    {/* Winder Process Detail */}
                    <TableCell sx={{ bgcolor: colors.greenAccent[400], textAlign: 'center' }}>RW QTY </TableCell>
                    <TableCell sx={{ bgcolor: colors.greenAccent[400], textAlign: 'center' }}> NO OF REELS </TableCell>
                    <TableCell sx={{ bgcolor: colors.greenAccent[400], textAlign: 'center' }}>RW QTY </TableCell>
                    <TableCell sx={{ bgcolor: colors.greenAccent[400], textAlign: 'center' }}>NO OF REELS</TableCell>
                    <TableCell sx={{ bgcolor: colors.greenAccent[400], textAlign: 'center' }}>RW  QTY </TableCell>
                    <TableCell sx={{ bgcolor: colors.greenAccent[400], textAlign: 'center' }}>NO OF REELS </TableCell>
                    <TableCell sx={{ bgcolor: colors.greenAccent[400], textAlign: 'center' }}>RW  QTY </TableCell>
                    <TableCell sx={{ bgcolor: colors.greenAccent[400], textAlign: 'center' }}>NO OF REELS </TableCell>
                    <TableCell sx={{ bgcolor: colors.greenAccent[400], textAlign: 'center' }}>RW  QTY </TableCell>
                    <TableCell sx={{ bgcolor: colors.greenAccent[400], textAlign: 'center' }}>NO OF REELS </TableCell>
                    <TableCell sx={{ bgcolor: colors.greenAccent[400], textAlign: 'center' }}>RW  QTY </TableCell>
                    <TableCell sx={{ bgcolor: colors.greenAccent[400], textAlign: 'center' }}>NO OF REELS </TableCell>
                    <TableCell sx={{ bgcolor: colors.greenAccent[400], textAlign: 'center' }}></TableCell>
                    <TableCell sx={{ bgcolor: colors.greenAccent[400], textAlign: 'center' }}></TableCell>

                    {/* reel weighment */}
                    <TableCell sx={{ bgcolor: colors.orangeAccent[400], textAlign: 'center' }}>REEL QTY</TableCell>
                    <TableCell sx={{ bgcolor: colors.orangeAccent[400], textAlign: 'center' }}>NO OF REEL</TableCell>
                    <TableCell sx={{ bgcolor: colors.orangeAccent[400], textAlign: 'center' }}>REEL QTY </TableCell>
                    <TableCell sx={{ bgcolor: colors.orangeAccent[400], textAlign: 'center' }}>NO OF REEL</TableCell>
                    <TableCell sx={{ bgcolor: colors.orangeAccent[400], textAlign: 'center' }}>REEL QTY</TableCell>
                    <TableCell sx={{ bgcolor: colors.orangeAccent[400], textAlign: 'center' }}>NO OF REEL</TableCell>
                    <TableCell sx={{ bgcolor: colors.orangeAccent[400], textAlign: 'center' }}>REEL QTY </TableCell>
                    <TableCell sx={{ bgcolor: colors.orangeAccent[400], textAlign: 'center' }}>NO OF REEL</TableCell>
                    <TableCell sx={{ bgcolor: colors.orangeAccent[400], textAlign: 'center' }}></TableCell>
                    <TableCell sx={{ bgcolor: colors.orangeAccent[400], textAlign: 'center' }}></TableCell>
                    <TableCell sx={{ bgcolor: colors.redAccent[400], textAlign: 'center' }}>REEL QTY</TableCell>
                    <TableCell sx={{ bgcolor: colors.redAccent[400], textAlign: 'center' }}>NO OF REES</TableCell>

                    {/* sheeter process */}

                    <TableCell sx={{ bgcolor: colors.purpleAccent[400], textAlign: 'center' }}>SHEET QTY</TableCell>
                    <TableCell sx={{ bgcolor: colors.purpleAccent[400], textAlign: 'center' }}>NO OF REELS</TableCell>
                    <TableCell sx={{ bgcolor: colors.purpleAccent[400], textAlign: 'center' }}>REEL QTY </TableCell>
                    <TableCell sx={{ bgcolor: colors.purpleAccent[400], textAlign: 'center' }}>NO OF REEL  </TableCell>
                    <TableCell sx={{ bgcolor: colors.purpleAccent[400], textAlign: 'center' }}>REEL QTY </TableCell>
                    <TableCell sx={{ bgcolor: colors.purpleAccent[400], textAlign: 'center' }}>NO OF REEL </TableCell>
                    <TableCell sx={{ bgcolor: colors.purpleAccent[400], textAlign: 'center' }}>REEL QTY </TableCell>
                    <TableCell sx={{ bgcolor: colors.purpleAccent[400], textAlign: 'center' }}>NO OF REEL </TableCell>
                    <TableCell sx={{ bgcolor: colors.purpleAccent[400], textAlign: 'center' }}></TableCell>
                    <TableCell sx={{ bgcolor: colors.purpleAccent[400], textAlign: 'center' }}></TableCell>
                    <TableCell sx={{ bgcolor: colors.redAccent[400], textAlign: 'center' }}>SHEET QTY</TableCell>
                    <TableCell sx={{ bgcolor: colors.redAccent[400], textAlign: 'center' }}>SHEET REELS</TableCell>

                    {/* ream punching */}
                    <TableCell sx={{ bgcolor: colors.yellowAccent[400], textAlign: 'center' }}>REAM QTY</TableCell>
                    <TableCell sx={{ bgcolor: colors.yellowAccent[400], textAlign: 'center' }}>NO OF REAM</TableCell>
                    <TableCell sx={{ bgcolor: colors.yellowAccent[400], textAlign: 'center' }}>REAM QTY </TableCell>
                    <TableCell sx={{ bgcolor: colors.yellowAccent[400], textAlign: 'center' }}>NO OF REAM  </TableCell>
                    <TableCell sx={{ bgcolor: colors.yellowAccent[400], textAlign: 'center' }}>REAM QTY </TableCell>
                    <TableCell sx={{ bgcolor: colors.yellowAccent[400], textAlign: 'center' }}>NO OF REAM </TableCell>
                    <TableCell sx={{ bgcolor: colors.yellowAccent[400], textAlign: 'center' }}>REAM QTY </TableCell>
                    <TableCell sx={{ bgcolor: colors.yellowAccent[400], textAlign: 'center' }}>NO OF REAM </TableCell>
                    <TableCell sx={{ bgcolor: colors.yellowAccent[400], textAlign: 'center' }}></TableCell>
                    <TableCell sx={{ bgcolor: colors.yellowAccent[400], textAlign: 'center' }}></TableCell>
                    <TableCell sx={{ bgcolor: colors.redAccent[400], textAlign: 'center' }}>PALLET QTY</TableCell>
                    <TableCell sx={{ bgcolor: colors.redAccent[400], textAlign: 'center' }}>NO OF PALLETS</TableCell>

                    {/* bundle */}
                    <TableCell sx={{ bgcolor: colors.orangeAccent[400], textAlign: 'center' }}>BUNDLE QTY</TableCell>
                    <TableCell sx={{ bgcolor: colors.orangeAccent[400], textAlign: 'center' }}>NO OF BUNDLE</TableCell>
                    <TableCell sx={{ bgcolor: colors.orangeAccent[400], textAlign: 'center' }}>BUNDLE QTY </TableCell>
                    <TableCell sx={{ bgcolor: colors.orangeAccent[400], textAlign: 'center' }}>NO OF BUNDLE </TableCell>
                    <TableCell sx={{ bgcolor: colors.orangeAccent[400], textAlign: 'center' }}>BUNDLE QTY </TableCell>
                    <TableCell sx={{ bgcolor: colors.orangeAccent[400], textAlign: 'center' }}>NO OF BUNDLE </TableCell>
                    <TableCell sx={{ bgcolor: colors.orangeAccent[400], textAlign: 'center' }}>BUNDLE QTY</TableCell>
                    <TableCell sx={{ bgcolor: colors.orangeAccent[400], textAlign: 'center' }}>NO OF BUNDLE </TableCell>
                    <TableCell sx={{ bgcolor: colors.orangeAccent[400], textAlign: 'center' }}>BUNDLE PROD. FIRST DATE</TableCell>
                    <TableCell sx={{ bgcolor: colors.orangeAccent[400], textAlign: 'center' }}>BUNDLE PROD.LAST DATE</TableCell>
                    <TableCell sx={{ bgcolor: colors.redAccent[400], textAlign: 'center' }}>REAM QTY</TableCell>
                    <TableCell sx={{ bgcolor: colors.redAccent[400], textAlign: 'center' }}>NO OF REAMS</TableCell>

                    {/* ream pallet */}
                    <TableCell sx={{ bgcolor: colors.purpleAccent[400], textAlign: 'center' }}>REAM PALLET QTY</TableCell>
                    <TableCell sx={{ bgcolor: colors.purpleAccent[400], textAlign: 'center' }}>NO OF REAM PALLET</TableCell>
                    <TableCell sx={{ bgcolor: colors.purpleAccent[400], textAlign: 'center' }}>REAM PALLET QTY </TableCell>
                    <TableCell sx={{ bgcolor: colors.purpleAccent[400], textAlign: 'center' }}>NO OF REAM PALLET </TableCell>
                    <TableCell sx={{ bgcolor: colors.purpleAccent[400], textAlign: 'center' }}>REAM PALLET QTY </TableCell>
                    <TableCell sx={{ bgcolor: colors.purpleAccent[400], textAlign: 'center' }}>NO OF REAM PALLET </TableCell>
                    <TableCell sx={{ bgcolor: colors.purpleAccent[400], textAlign: 'center' }}>REAM PALLET QTY</TableCell>
                    <TableCell sx={{ bgcolor: colors.purpleAccent[400], textAlign: 'center' }}>NO OF REAM PALLET </TableCell>
                    <TableCell sx={{ bgcolor: colors.purpleAccent[400], textAlign: 'center' }}>REAM PALLET PROD. FIRST DATE</TableCell>
                    <TableCell sx={{ bgcolor: colors.purpleAccent[400], textAlign: 'center' }}>REAM PALLET PROD.LAST DATE</TableCell>
                    {/* <TableCell sx={{ bgcolor: colors.redAccent[400], textAlign: 'center' }}>REAM QTY</TableCell>
                                        <TableCell sx={{ bgcolor: colors.redAccent[400], textAlign: 'center' }}>NO OF REAMS</TableCell> */}


                    <TableCell sx={{ bgcolor: colors.greenAccent[600], textAlign: 'center' }}></TableCell>
                    <TableCell sx={{ bgcolor: colors.greenAccent[600], textAlign: 'center' }}></TableCell>
                    <TableCell sx={{ bgcolor: colors.greenAccent[600], textAlign: 'center' }}></TableCell>
                    <TableCell sx={{ bgcolor: colors.greenAccent[600], textAlign: 'center' }}></TableCell>
                    <TableCell sx={{ bgcolor: colors.greenAccent[600], textAlign: 'center' }}></TableCell>
                    <TableCell sx={{ bgcolor: colors.greenAccent[600], textAlign: 'center' }}></TableCell>
                    <TableCell sx={{ bgcolor: colors.redAccent[400], textAlign: 'center' }}></TableCell>
                    <TableCell sx={{ bgcolor: colors.redAccent[400], textAlign: 'center' }}></TableCell>

                    <TableCell sx={{ bgcolor: colors.redAccent[400], textAlign: 'center' }}></TableCell>
                    <TableCell sx={{ bgcolor: colors.blueAccent[600], textAlign: 'center' }}></TableCell>
                    <TableCell sx={{ bgcolor: colors.blueAccent[600], textAlign: 'center' }}></TableCell>
                    <TableCell sx={{ bgcolor: colors.blueAccent[600], textAlign: 'center' }}></TableCell>
                    <TableCell sx={{ bgcolor: colors.blueAccent[600], textAlign: 'center' }}></TableCell>
                    <TableCell sx={{ bgcolor: colors.blueAccent[600], textAlign: 'center' }}></TableCell>
                    <TableCell sx={{ bgcolor: colors.blueAccent[600], textAlign: 'center' }}></TableCell>
                    <TableCell sx={{ bgcolor: colors.blueAccent[600], textAlign: 'center' }}></TableCell>

                </TableRow>

                <TableFilterRow
                    columns={columns}
                    filters={filters}
                    handleFilterChange={handleFilterChangeTable}
                    uniqueValues={uniqueValues}
                    autoCompleteColumns={autoCompleteColumns}
                />
            </TableHead>

            <TableBody>
                {currentRecords.map((row, index) => (
                    <TableRow
                        key={index}
                        sx={{
                            backgroundColor:
                                index % 2 === 0
                                    ? theme.palette.background.default
                                    : alpha(theme.palette.action.hover, 0.04),
                        }}
                    >
                        <TableCell>{row.indent_month}</TableCell>
                        <TableCell>{row.region}</TableCell>
                        <TableCell>{row.dealer}</TableCell>
                        <TableCell>{row.consignee}</TableCell>
                        {/* Delivery Name */}
                        <TableCell>{row.deliveryaddress}</TableCell>
                        {/* Destination */}
                        <TableCell>{row.destination}</TableCell>
                        <TableCell>{row.orderstatus}</TableCell>
                        {/* Order Block */}
                        <TableCell>-</TableCell>
                        <TableCell>{row.quality}</TableCell>
                        <TableCell>{row.gsm}</TableCell>
                        <TableCell>{row.width}</TableCell>
                        <TableCell>{row.length}</TableCell>
                        <TableCell>{row.packing_mode}</TableCell>
                        <TableCell>{row.so_date}</TableCell>
                        <TableCell>{row.requir_delivery_date}</TableCell>
                        <TableCell>-</TableCell>
                        <TableCell>{row.sap_po_no}</TableCell>
                        <TableCell>{row.sap_po_item_line}</TableCell>
                        <TableCell>{row.so_no}</TableCell>
                        <TableCell>{row.item_line}</TableCell>
                        {/* PO NO */}
                        <TableCell>{row.po_no}</TableCell>
                        {/* PO ITEM LINE */}
                        <TableCell>{row.po_date}</TableCell>
                        {/* <TableCell>{row.item_line}</TableCell> */}

                        {/* old modal */}
                        <TableCell>{row.so_number}</TableCell>
                        {/* <TableCell>{row.so_no}</TableCell>
                                            <TableCell>{row.l_order_punch_date}</TableCell> */}
                        <TableCell>{row.order_qty}</TableCell>
                        {/* MO DETAIL */}
                        <TableCell>{row.number_of_mo}</TableCell>
                        <TableCell>{row.deckle_qty}</TableCell>
                        <TableCell>{row.deckle_first_date}</TableCell>
                        <TableCell>{row.deckle_last_date}</TableCell>
                        <TableCell>{row.machine_pending_order}</TableCell>

                        {/* PARENT ROLL  */}
                        <TableCell>{row.number_of_parent_roll}</TableCell>
                        <TableCell>{row.ma_booked_quantity}</TableCell>
                        <TableCell>{row.machine_childroll_first_date}</TableCell>
                        <TableCell>{row.machine_childroll_last_date}</TableCell>
                        <TableCell>{row.wip_rw_qty}</TableCell>
                        {/* wip no of reels */}
                        <TableCell>-</TableCell>

                        {/* Winder Process */}
                        <TableCell>{row.total_rw_qty}</TableCell>
                        <TableCell>{row.total_rw_reels}</TableCell>
                        <TableCell>{row.rw_qty_g1}</TableCell>
                        <TableCell>{row.no_of_reels_g1}</TableCell>
                        <TableCell>{row.rw_qty_s1}</TableCell>
                        <TableCell>{row.no_of_reels_s1}</TableCell>
                        <TableCell>{row.rw_qty_buffer}</TableCell>
                        <TableCell>{row.no_of_reels_buffer}</TableCell>
                        <TableCell>{row.rw_qty_repulp}</TableCell>
                        <TableCell>{row.no_of_reels_repulp}</TableCell>
                        <TableCell>{row.rw_qty_un_approved}</TableCell>
                        <TableCell>{row.no_of_reels_un_approved}</TableCell>
                        <TableCell>{row.rw_first_date}</TableCell>
                        <TableCell>{row.rw_last_date}</TableCell>

                        {/* reel Weighment */}
                        <TableCell>{row.reel_weighment_qty}</TableCell>
                        <TableCell>{row.reel_weighment_reels}</TableCell>
                        <TableCell>{row.reel_order_qty_g1}</TableCell>
                        <TableCell>{row.no_of_reels}</TableCell>
                        <TableCell>{row.reel_qty_s1}</TableCell>
                        <TableCell>{row.reels_sl}</TableCell>
                        <TableCell>{row.reel_order_qty_repulp}</TableCell>
                        <TableCell>{row.reels_repulp}</TableCell>
                        <TableCell>{row.reel_prod_first_date}</TableCell>
                        <TableCell>{row.reel_prod_last_date}</TableCell>
                        <TableCell>{row.wip_reel_qty}</TableCell>
                        <TableCell>{row.wip_rw_reels}</TableCell>

                        {/* sheeter */}
                        <TableCell>{row.sheet_quantity}</TableCell>
                        <TableCell>{row.no_of_reels_sheet}</TableCell>
                        <TableCell>{row.sheet_g1_weight}</TableCell>
                        <TableCell>{row.sheet_g1_reels}</TableCell>
                        <TableCell>{row.sheet_sl_weight}</TableCell>
                        <TableCell>{row.sheet_sl_reels}</TableCell>
                        <TableCell>{row.sheet_repulp_weight}</TableCell>
                        <TableCell>{row.sheet_repulp_reels}</TableCell>
                        <TableCell>{row.sheeting_first_date}</TableCell>
                        <TableCell>{row.sheeting_last_date}</TableCell>
                        <TableCell>{row.wip_sheet_quantity}</TableCell>
                        <TableCell>{row.wip_sheet_reels}</TableCell>

                        {/* ream punching */}
                        <TableCell>{row.ream_qty}</TableCell>
                        <TableCell>{row.no_of_ream}</TableCell>
                        <TableCell>{row.ream_qty_g1}</TableCell>
                        <TableCell>{row.reams_g1}</TableCell>
                        <TableCell>{row.ream_qty_sl}</TableCell>
                        <TableCell>{row.reams_sl}</TableCell>
                        <TableCell>{row.ream_qty_repulp}</TableCell>
                        <TableCell>{row.reams_repulp}</TableCell>
                        <TableCell>{row.ream_prod_first_date}</TableCell>
                        <TableCell>{row.ream_prod_last_date}</TableCell>
                        <TableCell>{row.wip_ream_quantity}</TableCell>
                        <TableCell>{row.wip_pallet_count_val}</TableCell>

                        <TableCell>{row.bundle_qty}</TableCell>
                        <TableCell>{row.no_of_bundle}</TableCell>
                        <TableCell>{row.bundle_g1_weight}</TableCell>
                        <TableCell>{row.bundles_g1}</TableCell>
                        <TableCell>{row.bundle_quantity_sl}</TableCell>
                        <TableCell>{row.bundles_sl}</TableCell>
                        <TableCell>{row.repulp}</TableCell>
                        <TableCell>{row.bundles_repulp}</TableCell>
                        <TableCell>{row.bundle_prod_first_date}</TableCell>
                        <TableCell>{row.bundle_prod_last_date}</TableCell>
                        <TableCell>{row.wip_bundle_quantity}</TableCell>
                        {/* no of reels */}
                        <TableCell>{row.wip_ream_count_val}</TableCell>

                        {/* ream pallet */}
                        <TableCell>{row.ream_pallet_qty}</TableCell>
                        <TableCell>{row.no_of_ream_pallet}</TableCell>
                        <TableCell>{row.ream_pallet_g1_weight}</TableCell>
                        <TableCell>{row.ream_pallet_g1}</TableCell>
                        <TableCell>{row.ream_pallet_quantity_sl}</TableCell>
                        <TableCell>{row.ream_pallet_sl}</TableCell>
                        <TableCell>{row.ream_pallet_repulp_qty}</TableCell>
                        <TableCell>{row.ream_pallet_repulp}</TableCell>
                        <TableCell>{row.ream_pallet_prod_first_date}</TableCell>
                        <TableCell>{row.ream_pallet_prod_last_date}</TableCell>


                        <TableCell>{row.lodge_quantity}</TableCell>
                        <TableCell>{row.lodge_g1_quantity}</TableCell>
                        <TableCell>{row.lodge_sl_quantity}</TableCell>
                        <TableCell>{row.lodge_repulp_quantity}</TableCell>
                        <TableCell>{row.lodging_first_date}</TableCell>
                        <TableCell>{row.lodging_last_date}</TableCell>
                        <TableCell>{row.wip_lodge_quantity}</TableCell>
                        <TableCell>{row.lodge_repulp_qty}</TableCell>
                        <TableCell></TableCell>
                        <TableCell>{row.sap_fg_qty}</TableCell>
                        <TableCell>{row.sap_fg_first_date}</TableCell>
                        <TableCell>{row.sap_fg_last_date}</TableCell>
                        <TableCell>{row.despatch_qty}</TableCell>
                        <TableCell>{row.despatch_first_date}</TableCell>
                        <TableCell>{row.despatch_last_date}</TableCell>
                        <TableCell>{row.overall_balance_qty}</TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    </>);
}
export default ProductionReportTable;